<div (window:resize)="resize()" [formGroup]="parentForm" #upload_div>
  <div formArrayName="upload_files_attributes">
    @for (file of formUploadFiles; track file; let i = $index) {
      <div [formGroupName]="i">
        @if (!file.controls._destroy.value) {
          <div class="attach">
            @if (canEdit) {
              <a class="spen-util-link" (click)="deleteFileAttach(i)"> {{ layoutService.isTabletDownView.value ? '削除' : '削除する' }}</a>
            }
            <div class="attach-image">
              @if (file.controls.id.value) {
                <div>
                  @if (!!file.controls.thumbnail.value) {
                    <div class="attach-file">
                      <img [src]="file.controls.thumbnail.value" />
                    </div>
                  } @else {
                    <i [ngClass]="file.controls.file_name.value | fileIconClass"></i>
                  }
                </div>
              } @else {
                @if (isShowPreview(uploader.queue[i - filesAttachNumber])) {
                  <div class="attach-file">
                    <img appImagePreview [image]="file.controls.thumbnail.value" />
                  </div>
                } @else {
                  <i [ngClass]="file.controls.file_name.value | fileIconClass"></i>
                }
              }
            </div>
            <p class="file-name truncate-text">{{ file.controls.file_name.value }}</p>
            <textarea
              class="spen-mod-input-text"
              type="text"
              [appPlaceholder]="'このファイルは何ですか？'"
              formControlName="caption"
            ></textarea>
            @if (!layoutService.isTabletDownView.value) {
              <p class="text-num pull-right">
                文字数<span>{{ getLengthCaption(i) }}</span>
              </p>
            }
            @if (getFormErrorsCaption(i)) {
              <div class="caption-error">
                <div class="spen-mod-error-content">
                  {{ getFormErrorsCaption(i).join(' ') }}
                </div>
              </div>
            }
            @if (layoutService.isTabletDownView.value) {
              <div class="text-num">
                <p>
                  文字数<span>{{ getLengthCaption(i) }}</span>
                </p>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>

<div class="create-new">
  <label class="spen-util-link" [ngClass]="{ 'disable-upload-btn': getAllFilesNumber >= MaxFilesCount }" for="file-upload">
    <i class="fa fa-plus-circle"></i>ファイルを添付する</label
  >
  <input
    id="file-upload"
    class="input-file"
    type="file"
    (change)="onSelectFile($event)"
    [accept]="acceptTypes"
    ng2FileSelect
    [uploader]="uploader"
    multiple
  />
</div>

<p class="annotation">※ 添付できるファイルの上限は50個までです。</p>

@if (attachFilesErrMsg) {
  <div class="file-error">
    <div class="spen-mod-error-content">
      {{ attachFilesErrMsg }}
    </div>
  </div>
}

@if (showProgressbar) {
  <app-upload-files-progress [progress]="uploader.progress" (cancelFilesEvent)="cancelUploadingFiles()"> </app-upload-files-progress>
}
